import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import ContentTitle from '../shared/ContentTitle'
import ReactSelect from 'react-select'
import { InvoiceService } from '../../../services'
import { startFetch, endFetch } from '../../../actions/generalActions'
import ToastService from '../shared/Toast/ToastService'

class InvoiceValidationForm extends Component {
  state = {
    approveReasons: [],
    reprovedReasons: [],
    selectedReason: null,
    approved: null,
    errors: {},
  }

  componentDidMount() {
    this.fetchReasons()
  }

  fetchReasons = () => {
    const { campaign } = this.props
    InvoiceService.getValidationReasons({ campaignId: campaign.slug })
      .then(response => {
        const { approved_reasons, reproved_reasons } = response.data
        this.setState({ approveReasons: approved_reasons, reprovedReasons: reproved_reasons })
      })
      .catch(() => {})
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { campaign, match } = this.props
    const { approved, selectedReason } = this.state

    if (approved === null) {
      ToastService.error('Selecione uma opção de aprovação')
      return
    }
    if (!selectedReason) {
      ToastService.error('Selecione uma razão')
      return
    }

    const body = { approved, reason_id: selectedReason.id }
    this.props.startFetch()
    InvoiceService.validateInvoice({
      campaignId: campaign.slug,
      invoiceId: match.params.id,
      body,
    })
      .then(() => {
        this.props.endFetch()
        this.props.history.push('/invoice')
      })
      .catch(error => {
        this.props.endFetch()
        if (error.response && error.response.data) {
          this.setState({ errors: error.response.data })
        }
      })
  }

  handleApprove = (e) => {
    e.preventDefault()
    this.setState({ approved: true, selectedReason: null })
  }

  handleReprove = (e) => {
    e.preventDefault()
    this.setState({ approved: false, selectedReason: null })
  }

  render() {
    const { campaign } = this.props
    const { approved, approveReasons, reprovedReasons, selectedReason, errors } = this.state

    return (
      <div className="template-container">
        <ContentTitle title="Validar Fatura" sub campaign={campaign} />
        <form onSubmit={this.handleSubmit}>
          <div className="flex mb-4 gap-4">
            <button
              onClick={this.handleApprove}
              className={`rounded px-4 py-2 border ${approved === true ? 'primary-bg navbar-text' : 'primary-border primary-text border'}`}
              type="button"
            >
              Aprovar
            </button>
            <button
              onClick={this.handleReprove}
              className={`rounded px-4 py-2 border ${approved === false ? 'primary-bg navbar-text' : 'primary-border primary-text border'}`}
              type="button"
            >
              Reprovar
            </button>
          </div>

          {approved !== null && (
            <InputContainer label={approved ? 'Razão de Aprovação' : 'Razão de Reprovação'}>
              <ReactSelect
                isClearable
                onChange={(val) => this.setState({ selectedReason: val })}
                options={approved ? approveReasons : reprovedReasons}
                value={selectedReason}
                getOptionLabel={(o) => o.reason}
                getOptionValue={(o) => o.id}
                placeholder="selecionar razão..."
                className="w-full"
                classNamePrefix="custom-select"
              />
              {errors.reason_id && (
                <p className="invoice-error text-sm mt-1">{errors.reason_id.join(', ')}</p>
              )}
            </InputContainer>
          )}

          {approved !== null && (
            <div className="flex justify-end mt-4">
              <button className="rounded primary-bg navbar-text px-5 py-3" type="submit">
                Guardar Validação
              </button>
            </div>
          )}
        </form>
      </div>
    )
  }
}

const InputContainer = ({ label, children }) => (
  <div className="flex flex-col mb-4 font-quicksand-light">
    <label className="mb-1 text-lg">{label}</label>
    {children}
  </div>
)

const mapDispatchToProps = (dispatch) => ({
  startFetch: () => dispatch(startFetch()),
  endFetch: () => dispatch(endFetch()),
})

export default withRouter(connect(null, mapDispatchToProps)(InvoiceValidationForm))
